module.exports = __webpack_public_path__ + "img/base_divers_top20.00981f48.svg";